import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Tabs from '../common/Tabs';

export interface GeographyFilterProps {
	onChange: (value: ''|'federal'|'regional') => void,
};

const geography_ru = ['Все', 'Федеральные', 'Региональные'];
const geography_en = ['All', 'Federal', 'Regional'];

const GeographyFilter: FC<GeographyFilterProps> = ({ onChange }) => {
	const { i18n } = useTranslation();
	const list = i18n.language === 'en' ? geography_en : geography_ru;
    const [ current, setCurrent ] = useState(list[0]);

    useEffect(() => {
        setCurrent(list[0]);
    }, [ list ]);

    const changed = (item: string) => {
        setCurrent(item);
        switch(item) {
            case list[0]:
                onChange('');
                break;
            case list[1]:
                onChange('federal');
                break;
            case list[2]:
                onChange('regional');
                break;
            default:
                break;
        }
    };

    return (
		<div className='GeographyFilter'>
            <Tabs
                list={list}
                current={current}
                className='white'
                onChange={changed}
            />
	    </div>
    );
};

export default GeographyFilter;
